var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    d: "M7.28613 5H6.78613C6.78613 4.81824 6.88477 4.65079 7.04375 4.56268C7.20273 4.47457 7.397 4.47967 7.55113 4.576L7.28613 5ZM15.2861 10L15.5511 9.576C15.6973 9.66737 15.7861 9.8276 15.7861 10C15.7861 10.1724 15.6973 10.3326 15.5511 10.424L15.2861 10ZM7.28613 15L7.55113 15.424C7.397 15.5203 7.20273 15.5254 7.04375 15.4373C6.88477 15.3492 6.78613 15.1818 6.78613 15H7.28613ZM7.55113 4.576L15.5511 9.576L15.0211 10.424L7.02113 5.424L7.55113 4.576ZM15.5511 10.424L7.55113 15.424L7.02113 14.576L15.0211 9.576L15.5511 10.424ZM7.78613 5V15H6.78613V5H7.78613Z",
    fill: "#1D1D46"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-circle": "stroke",
    cx: 10.2861,
    cy: 10,
    r: 9,
    stroke: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.e1de601d2e3ef27ab8ff7659db7e1fb4.svg";
export { ForwardRef as ReactComponent };